<template>
  <!-- -->
  <div class="distributed">
    <Head :index="'4'"></Head>
    <div class="chartTop">
      <div class="fl">
        <el-button-group>
          <el-button @click="tabClass('table')" :class="{ active: type == 'table' }">列表</el-button>
          <el-button @click="tabClass('map')" :class="{ active: type == 'map' }">地图</el-button>
        </el-button-group>
      </div>
      <div class="fr"></div>
    </div>
    <div v-if="type == 'table'" style="width: 100%;height:100%">
      <el-table :data="tableData" border :span-method="objectSpanMethod1"
                style="width: 98%;height:calc(100% - 115px);margin:0 1%">
        <el-table-column prop="name" width="100" label="姓名"></el-table-column>
        <el-table-column prop="shixu" width="100" label="世序"></el-table-column> 
        <el-table-column prop="fromaddress" label="迁出地"></el-table-column>
        <el-table-column prop="toaddress"  label="迁入地"></el-table-column>
        <el-table-column prop="migrationdate" label="迁徙时间"></el-table-column>
        <el-table-column prop="migrationreasons"  label="迁徙原因"></el-table-column>
      </el-table>
    </div>
    <div v-else class="amap-page-container">
      <div class="checkbox-group">
        <div style="border-bottom: 2px solid #8c939d;padding-left: 5px;padding-top:3px">
          <el-checkbox v-model="isCheckboxChecked" @change="handleCheckboxChange">自动滚动显示</el-checkbox>
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">显示全部
          </el-checkbox>
        </div>
        <div style="margin: 15px 0;"></div>
        <!--        <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">-->
        <!--          <el-checkbox v-for="(item, index) in checkData" :label="index" :key="index">{{-->
        <!--              item.name.split("|")[0] + " (" + item.name.split("|")[1] + ")"-->
        <!--            }}</el-checkbox>-->
        <!--        </el-checkbox-group>-->
        <el-radio-group ref="radioGroup" v-model="checkList" @change="handleCheckedCitiesChange">
          <el-radio v-for="(item, index) in checkData" :label="index" :key="index"
          >{{ item.name.split("|")[0] + " (" + item.name.split("|")[1] + ")" }}
          </el-radio>
        </el-radio-group>
      </div>
      <div class="amap-page-container">
        <el-amap :zoom="zoom" :center="center" view-mode="3D" :pitch="0" :show-label="true" class="amap-demo">
          <el-amap-loca @init="initLoca">
            <el-amap-loca-pulse-line
              :visible="visible"
              @click="eventsFun"
              :depth="true"
              :source-data="sourceData"
              :layer-style="layerStyle"
            ></el-amap-loca-pulse-line>
          </el-amap-loca>
        </el-amap>
      </div>
    </div>

    <ul class="ry" v-show="liData.length != 0">
      <li v-for="(item, index) in liData" :key="index">
        <p>{{ item.names }}</p>
        <p>迁出地：{{ item.fromName }}</p>
        <p>迁入地：{{ item.toName }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import Head from "@/components/header.vue";
import api from "@/request/api";

var headColors = ["#ECFFB1", "#146968", "#146968", "#146968", "#146968", "#146968", "#146968", "#146968"];
var trailColors = [
  "rgba(255,178,6, 0.2)",
  "rgba(255,178,6, 0.2)",
  "rgba(20,105,104, 0.2)",
  "rgba(20,105,104, 0.2)",
  "rgba(20,105,104, 0.2)",
  "rgba(20,105,104, 0.2)",
  "rgba(20,105,104, 0.2)",
  "rgba(20,105,104, 0.2)"
];
export default {
  data() {
    let self = this;
    return {
      zoom: 5.29,
      center: [109.595668, 35.447184],
      visible: true,
      sourceData: {},
      checkData: {},
      checkList: "",
      checkAll: true,
      isIndeterminate: false,
      layerStyle: {
        altitude: 0,
        lineWidth: (_, feature) => 4,
        headColor: (_, feature) => "red",
        showDir: true,
        // headColor: (_, feature) => headColors[feature.properties.type],
        trailColor: (_, feature) => "#ECFFB1",
        // trailColor: (_, feature) => trailColors[feature.properties.type],
        interval: 0.5,
        duration: 10000
      },
      lines: [],
      liData: [],
      type: "map",
      tableData: [],
      isCheckboxChecked: false, // 复选框是否选中
      currentIndex: 0, // 当前选中的radio索引
      timer: null // 定时器
    };
  }, 

  created() {
    // let self = this;
    // let basePosition = [];
    // ///getancestorarea

    api.familyGet(localStorage.getItem("fid")).then((res) => {
      if (res.data.coordinate == "") {
        this.center = [116.367827, 40.0865];
      } else {
        this.center = res.data.coordinate.split(", ");
      }
    });

    api.migrateToByName({id: localStorage.getItem("fid"), type: 1}).then((res) => {
      this.checkData = res.data;
      this.handleCheckAllChange(true);
    });

    api.migrateToByName({id: localStorage.getItem("fid"), type: 0}).then((res) => {
      for (var i = 0; i < res.data.length; i++) {
        for (var s = 0; s < res.data[i].datas.length; s++) {
          this.tableData.push(res.data[i].datas[s]);
        }
      }
      
    });

    
  },

  methods: {
    handleCheckboxChange() {
      this.liData=[]
      var that = this;
      if (this.isCheckboxChecked) {
        // 复选框选中时开始轮流选中radio
        let ind = 0;
        this.timer = setInterval(function () {
          that.checkList = ind;
          that.handleCheckedCitiesChange(ind);
          if (ind < that.checkData.length) {
            ind = ind + 1;
          } else {
            clearInterval(this.timer);
          }
        }, 1000); // 每秒钟选中下一个radio
      } else {
        // 复选框取消选中时停止轮流选中radio
        clearInterval(this.timer);
      }
    },
    handleCheckAllChange(val) {
      this.liData=[]
      let options = [];
      let data = [];
      for (let i = 0; i < this.checkData.length; i++) {
        options.push(i);
        if (val) {
          let arr = [];
          for (let j = 0; j < this.checkData[i].datas.length; j++) {
            arr.push(this.checkData[i].datas[j].coords[0]);
            arr.push(this.checkData[i].datas[j].coords[1]);
          }

          data.push({
            type: "Feature",
            name: this.checkData[i].name,
            geometry: {
              type: "LineString",
              coordinates: arr,
              fromName: this.checkData[i].datas[0].fromaddress,
              names: this.checkData[i].datas[0].name,
              toName: this.checkData[i].datas[0].toaddress
            }
          });
        }
      }
      this.checkList = val ? options : [];
      this.isIndeterminate = val;
      this.sourceData = {
        type: "FeatureCollection",
        features: data
      };
      // console.log(this.sourceData,'----sourceData22');
      
      this.$forceUpdate();
    },
    handleCheckedCitiesChange(value) {
      this.liData=[]
      let options = [];
      let data = [];
      for (let i = 0; i < this.checkData.length; i++) {
        if (i == value) {
          let arr = [];
          for (let c = 0; c < this.checkData[i].datas.length; c++) {
            arr.push(this.checkData[i].datas[c].coords[0]);
            arr.push(this.checkData[i].datas[c].coords[1]);
          }
          data.push({
            type: "Feature",
            name: this.checkData[i].name,
            geometry: {
              type: "LineString",
              coordinates: arr,
              fromName: this.checkData[i].datas[0].fromaddress,
              names: this.checkData[i].datas[0].name,
              toName: this.checkData[i].datas[0].toaddress
            }
          });
        }
      }
      // let checkedCount = value.length;
      // this.checkAll = checkedCount > 0 && checkedCount === options.length;
      // this.isIndeterminate = checkedCount > 0 && checkedCount < options.length;

      this.sourceData = {
        type: "FeatureCollection",
        features: data
      };
      // console.log(this.sourceData,'----sourceData111');
      this.$forceUpdate();
    },
    eventsFun(e) {
      if (e != undefined) {
        this.liData = [e];
      }
    },
  
    toggleVisible() {
      this.visible = !this.visible;
    },
    initLoca(loca) {
      loca.animate.start();
    },
    tabClass(val) {
      this.type = val;
    },
    objectSpanMethod1({row, column, rowIndex, columnIndex}) {
      var data = this.tableData;
      if (columnIndex == 0) {
        let prevRow = data[rowIndex - 1]; //获取到上一条数据
        let nextRow = data[rowIndex + 1]; //下一条数据
        if (prevRow && prevRow[column.property] === row[column.property]) {
          //当有上一条数据，并且和当前值相等时
          return {rowspan: 0, colspan: 0};
        } else {
          let countRowspan = 1;
          while (nextRow && nextRow[column.property] === row[column.property]) {
            //当有下一条数据并且和当前值相等时,获取新的下一条
            nextRow = data[++countRowspan + rowIndex];
          }
          if (countRowspan > 1) {
            return {rowspan: countRowspan, colspan: 1};
          }
        }
      } else if (columnIndex == 1) {
        let prevRow = data[rowIndex - 1]; //获取到上一条数据
        let nextRow = data[rowIndex + 1]; //下一条数据
        let nowStr = row["name"] + row["shixu"];
        if (prevRow && prevRow["name"] + prevRow["shixu"] === nowStr) {
          return {rowspan: 0, colspan: 0};
        } else {
          let countRowspan = 1;
          while (nextRow && nextRow["name"] + nextRow["shixu"] === nowStr) {
            //当有下一条数据并且和当前值相等时,获取新的下一条
            nextRow = data[++countRowspan + rowIndex];
          }
          if (countRowspan > 1) {
            return {rowspan: countRowspan, colspan: 1};
          }
        }
      }
    }
  },
  components: {
    Head
  }
};
</script>
<style lang="less" scoped>
// .amap-demo {
//     height: 300px !important;
// }
.distributed {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .chartTop {
    height: 55px;
    line-height: 55px;
    padding-right: 20px;

    .active {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
    }

    button {
      color: #000;
    }
  }

  /deep/ .el-table {
    .el-table__body-wrapper {
      overflow: auto;
      width: 100%;
      height: 100%;
    }

    border: 1px solid #000000 !important;
  }
  /deep/ .el-table__header th {
    background: #f5f7fa;
}
  /deep/ .el-table--border th.el-table__cell,
  /deep/ .el-table__fixed-right-patch,
  /deep/ td.el-table__cell,
  /deep/ th.el-table__cell.is-leaf {
    border-bottom: 1px solid #000000 !important;
  }

  /deep/ .el-table--border .el-table__cell {
    border-right: 1px solid #000 !important;
    padding: 6px 0;
  }

  /deep/ .el-table--border,
  /deep/ .el-table--group {
    border: 1px solid #000000 !important;
  }

  .amap-page-container {
    width: 100%;
    height: 100%;
    position: relative;

    .checkbox-group {
      position: absolute;
      background: #fff;
      z-index: 100;
      width: 200px;
      height: 85%;
      overflow-x: auto;
      padding: 20px;
      overflow: hidden;
      overflow-y: auto;
    }

    // height: calc(100% - 115px);
    .search-box {
      position: absolute;
      top: 25px;
      left: 20px;
    }

    .amap-div {
      width: 100%;
      height: 100%;
      position: relative;
    }
  }

  .ry {
    width: 375px;
    overflow-y: hidden;
    background: #fff;
    max-height: calc(100vh - 120px);
    box-shadow: 0 0 8px 0 #a2a2a2;
    border-radius: 4px;
    position: absolute;
    top: 88px;
    right: 24px;
    padding: 16px;
    z-index: 9;
  }

  .fl {
    padding-left: 20px;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/migrate.vue